import { render } from "./CollectionDetailPage.vue?vue&type=template&id=286f0698&scoped=true&ts=true"
import script from "./CollectionDetailPage.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailPage.vue?vue&type=script&lang=ts"

import "./CollectionDetailPage.vue?vue&type=style&index=0&id=286f0698&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286f0698"]])

export default __exports__